module.exports = __webpack_public_path__ + "Roboto-Bold.93f8dd3c8c656122f795.woff";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/src/assets/fonts/Roboto-Bold.woff
// module id = ../../../../../src/assets/fonts/Roboto-Bold.woff
// module chunks = styles